class Queue {
    constructor () {
        this.queue = []
        this.processing = false
        this._onEmpty = () => {}
    }

    onInit () {
    }

    onEmpty(cb) {
        this._onEmpty = cb
    }

    add (job) {
        this.queue.push(job)
        if (!this.processing) {
            this.process()
        }
    }

    async process () {
        this.processing = true
        if (this.queue.length === 0) {
            this.processing = false
            this._onEmpty()
            return false
        } else {
            let job = this.queue.shift()
            try {
                await job()
            } catch (e) {
                console.error(e)
            }
            this.process()
        }
    }
}

export default Queue
